import { render, staticRenderFns } from "./SetWebhook.vue?vue&type=template&id=634b0aa5"
import script from "./SetWebhook.vue?vue&type=script&lang=js"
export * from "./SetWebhook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports